module.exports = __webpack_public_path__ + "static/media/sur_abajo(1).beda761c.jpg";